/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Vendor_Return_Credit_Not_OpenInputs */

const en_error_vendor_return_credit_not_open = /** @type {(inputs: Error_Vendor_Return_Credit_Not_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The credit note of this vendor return cannot be approved: it is not executed, nothing was shipped back, or it is approved already.`)
};

/**
* | output |
* | --- |
* | "The credit note of this vendor return cannot be approved: it is not executed, nothing was shipped back, or it is approved already." |
*
* @param {Error_Vendor_Return_Credit_Not_OpenInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_vendor_return_credit_not_open = /** @type {((inputs?: Error_Vendor_Return_Credit_Not_OpenInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Vendor_Return_Credit_Not_OpenInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_vendor_return_credit_not_open(inputs)
});